import { resources } from "@constants/hardcoded-strings";
import { formatEmailTemplate } from "@formatters/email-templates/email-template-formatter";
import { FormattedEmailTemplate } from "@idw-types/data/email-template";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { setEmailTemplateDetails } from "@redux/actions/email-template-details-actions";
import { updateEmailTemplateRequest } from "@requests/axnadmin-core/update-email-templates";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getUnformattedLanguageFiles } from "@utils/email-template/email-template-util";
import { Dispatch } from "redux";

export const updateEmailTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    emailTemplate: FormattedEmailTemplate,
    axnCompanies: Array<AxnCompany>,
) => {
    const { data, error, body } = await updateEmailTemplateRequest(
        emailTemplate.id,
        emailTemplate.template,
        emailTemplate.name,
        emailTemplate.company?.id,
        emailTemplate.rpServiceID,
        getUnformattedLanguageFiles(emailTemplate.languages),
        emailTemplate.status,
        emailTemplate.uuid,
        emailTemplate.permissions,
        emailTemplate.sender
    );

    if (data) {
        const formattedEmailTemplate = formatEmailTemplate({ ...data.transferObject, permissions: emailTemplate.permissions }, axnCompanies);
        dispatch(setEmailTemplateDetails(formattedEmailTemplate));

        displaySuccessModal(
            dispatch,
            resources.requests.updateEmailTemplate.success.title,
            resources.requests.updateEmailTemplate.success.message
        );
        return formattedEmailTemplate;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateEmailTemplate.error.title,
            resources.requests.updateEmailTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};